import Action from './Action'
import Activity from './Activity'
import Goal from './Goal'

type Routine = {
  id?: string
  title: string
  description: string
  instructions: string
  expectedTime: number
  imageContentName: string
  activity?: Activity
  goal?: Goal
  actions: Action[]
  isFeatured: boolean
  isPublished: boolean
  imageType: 'Emoji' | 'Hero'
}
export default Routine

export const routineToJson = (routine: Routine) => {
  return {
    id: routine.id ? routine.id : undefined,
    title: routine.title,
    description: routine.description,
    instructions: routine.instructions,
    expectedTime: routine.expectedTime,
    imageContentName: routine.imageContentName ? routine.imageContentName : undefined,
    actionIds: routine.actions.map((a) => a.id),
    activityId: routine.activity ? routine.activity.id : undefined,
    goalId: routine.goal ? routine.goal.id : undefined,
    isFeatured: routine.isFeatured,
    isPublished: routine.isPublished,
    imageType: routine.imageType,
  }
}

export const routineFromJson = (json: object) => json as Routine
